import { Injectable } from '@angular/core';
import { DeviceDetectorService, DEVICES, OS, BROWSERS } from 'ngx-device-detector';

@Injectable()
export class ResponsiveService {
  public isDesktopDevice: boolean;
  public isIPhoneOrIPad: boolean;
  public isIPhone: boolean;
  public isIos: boolean;
  public isIeOrEdge: boolean;
  public isIe: boolean;
  public isTouchscreenDevice: boolean;
  public isWindowsOS: boolean;

  constructor(private readonly deviceDetectorService: DeviceDetectorService) {
    this.isDesktopDevice = this.deviceDetectorService.isDesktop();
    this.isIPhone = this.deviceDetectorService.device() === DEVICES.IPHONE;
    this.isIPhoneOrIPad = this.getIsIPhoneOrIPad();
    this.isIos = this.getIsIos();
    this.isIeOrEdge = this.getIsIeOrEdge();
    this.isIe = this.getIsIe();
    this.isTouchscreenDevice = this.isTouchscreen();
    this.isWindowsOS = this.getIsWindowsOS();

    if (this.isIPhoneOrIPad) {
      document.documentElement.style.cursor = 'pointer';
    }
  }

  public isDesktop(): boolean {
    return this.isDesktopDevice && this.isDesktopWidth();
  }

  public isDesktopWidth(): boolean {
    return window.innerWidth > 1024;
  }

  public isTabletWidth(): boolean {
    return window.innerWidth >= 768 && !this.isDesktopWidth();
  }

  public isMobileWidth(): boolean {
    return window.innerWidth < 768;
  }

  public isTouchscreen(): boolean {
    return 'ontouchstart' in document.documentElement;
  }

  private getIsIPhoneOrIPad(): boolean {
    return this.isIPhone || this.deviceDetectorService.device() === DEVICES.iPad;
  }

  private getIsIos(): boolean {
    return this.deviceDetectorService.os() === OS.IOS || this.deviceDetectorService.os() === OS.MAC;
  }

  private getIsIeOrEdge(): boolean {
    return (
      this.deviceDetectorService.browser() === BROWSERS.MS_EDGE ||
      this.deviceDetectorService.browser() === BROWSERS.MS_EDGE_CHROMIUM ||
      this.deviceDetectorService.browser() === BROWSERS.IE
    );
  }

  private getIsIe(): boolean {
    return this.deviceDetectorService.browser() === BROWSERS.IE;
  }

  private getIsWindowsOS(): boolean {
    return this.deviceDetectorService.os() === OS.WINDOWS;
  }
}
